<span class="text display-name">
  <ng-container *ngIf="multipleUserExceptionAccess; else singleAssignment">
    <ng-container *ngFor="let item of assignment;">
      {{ item.userName }}
      <span *ngIf="hasUserExceptionAccess(item.userId)" class="exception-asterisk"> *</span>
    </ng-container>
  </ng-container>
  <ng-template #singleAssignment>
    {{ assignment }}
    <span *ngIf="hasUserExceptionAccess(userId)" class="exception-asterisk"> *</span>
  </ng-template>
</span>